// extracted by mini-css-extract-plugin
export default {"question-policy-search":"styles_question-policy-search__8WsjX"};